/* eslint-disable react/prop-types */
import React, { forwardRef } from 'react';
import { Popover as AntPopover } from 'antd';

const Popover: typeof AntPopover = forwardRef(({ className, ...props }, ref) => (
  <AntPopover ref={ref} overlayClassName={className} {...props} />
));

export default Popover;
